import React, { useEffect, useRef } from 'react';
import { Modal, Input, Form } from 'antd';
import './RenameDialog.css';
import saveChat from '../../../assets/save.png';
import { NodeCategory } from 'api/useChat';
import { useChatState } from '../state/chatState';

const RenameDialog: React.FC = () => {
  const [form] = Form.useForm();
  const {
    state: { dialogs },
    closeRenameDialog,
    renameSessionItem,
    renameProjectItem
  } = useChatState();
  const { rename } = dialogs;
  const textAreaRef = useRef<any>(null);

  useEffect(() => {
    if (rename.isOpen) {
      form.setFieldsValue({ title: rename.title });
      setTimeout(() => {
        textAreaRef.current?.focus();
      }, 100);
    }
  }, [rename.title, rename.isOpen, form]);

  const renderDialogTitle = () => {
    switch (rename.nodeCategory) {
      case NodeCategory.SESSION:
        return 'Rename Session';
      case NodeCategory.PROJECT:
        return 'Rename Project';
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (rename.nodeCategory === NodeCategory.PROJECT) {
        await renameProjectItem(rename.projectIndex, values.title, rename.category);
      } else {
        await renameSessionItem(
          rename.sessionId,
          values.title,
          rename.sessionIndex,
          rename.updatedAt,
          rename.projectIndex,
          rename.category
        );
      }
      form.resetFields();
      closeRenameDialog();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title={renderDialogTitle()}
      open={rename.isOpen}
      className="no-divider-modal"
      onCancel={closeRenameDialog}
      footer={
        <div className="flex justify-start">
          <button
            className="bg-[#1a2b4b] text-white px-4 py-2 rounded-md border-none text-sm cursor-pointer"
            onClick={handleOk}
          >
            <img src={saveChat} alt="save" className="w-3 h-3 mr-2" />
            Save Changes
          </button>
          <button
            className="bg-transparent border-none text-gray-500 px-4 py-2 cursor-pointer text-sm"
            onClick={closeRenameDialog}
          >
            Cancel
          </button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          rules={[
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.reject(`${rename.nodeCategory} title cannot be empty`);
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input.TextArea
            ref={textAreaRef}
            placeholder={`Enter new ${rename.nodeCategory} title`}
            autoSize={{ minRows: 3, maxRows: 3 }}
            className="rounded-lg"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameDialog;
